export default __webpack_public_path__ + "static/media/1.3939ec49.png";